import { gql, OperationVariables, useQuery } from "@apollo/client"
import { CountrySalesFields } from "~/shared/fragments/CountrySalesFields"
import { CountrySales } from "@oysterhr/schema"

const CompanyVATPreferencesQuery = gql`
  query CompanyVATPreferences($companyId: ID!) {
    company(companyId: $companyId) {
      id
      countrySales {
        ...CountrySalesFields
      }
    }
  }
  ${CountrySalesFields}
`
type CompanyVATPreferencesPayload = {
  id: string
  countrySales: CountrySales
}
export const useCompanyVATPreferences = (options: OperationVariables) => {
  return useQuery<{ company: CompanyVATPreferencesPayload }>(CompanyVATPreferencesQuery, {
    ...options,
    fetchPolicy: "cache-and-network",
  })
}
